import { render, staticRenderFns } from "./InfoExamCategory.vue?vue&type=template&id=7efe0706&scoped=true"
import script from "./InfoExamCategory.vue?vue&type=script&lang=js"
export * from "./InfoExamCategory.vue?vue&type=script&lang=js"
import style0 from "./InfoExamCategory.vue?vue&type=style&index=0&id=7efe0706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe0706",
  null
  
)

export default component.exports